module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/score3.e2f4572e.png";